import React from 'react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const ShippingAndExchange10 = () => {
    const shippingSections = [
        {
            title: 'Shipping',
            items: [
                {
                    subtitle: 'Standard Shipping',
                    text: '5-7 business days within India. Free on all orders above ₹1,499.',
                },
                {
                    subtitle: 'Express Shipping',
                    text: '2-3 business days. Available at checkout for ₹249.',
                },
                {
                    subtitle: 'Processing Time',
                    text: 'As our garments are handcrafted, please allow 2-3 business days for order processing before dispatch.',
                },
            ],
        },
        {
            title: 'Returns',
            items: [
                {
                    subtitle: 'Return Window',
                    text: 'We accept returns within 14 days of delivery. Items must be unworn, unwashed, and in their original packaging with all tags attached.',
                },
                {
                    subtitle: 'Non-Returnable Items',
                    text: 'Custom or personalised orders, sale items, and intimate wear cannot be returned.',
                },
                {
                    subtitle: 'How to Return',
                    text: 'Contact us at hello@sthir.in with your order number. We will arrange a pickup or provide return shipping instructions.',
                },
            ],
        },
        {
            title: 'Exchanges',
            items: [
                {
                    subtitle: 'Size Exchange',
                    text: 'We offer one free size exchange per order within 14 days of delivery, subject to availability.',
                },
                {
                    subtitle: 'Process',
                    text: 'Contact our team to initiate an exchange. We will ship the replacement once we receive the original item.',
                },
            ],
        },
        {
            title: 'Refunds',
            items: [
                {
                    subtitle: 'Processing Time',
                    text: 'Refunds are processed within 5-7 business days after we receive the returned item and verify its condition.',
                },
                {
                    subtitle: 'Refund Method',
                    text: 'Refunds are issued to the original payment method. Bank processing times may add 3-5 additional business days.',
                },
            ],
        },
    ];

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-12 md:py-20 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <h1 className="text-2xl md:text-4xl font-light text-[#1C1917] tracking-tight">Shipping & Returns</h1>
                    </div>

                    <div className="max-w-[700px] mx-auto px-5 md:px-8 py-10 md:py-16">
                        <div className="space-y-14">
                            {shippingSections.map((section, sIdx) => (
                                <div key={sIdx}>
                                    <h2 className="text-[#1C1917] text-xs tracking-[2px] uppercase mb-6">{section.title}</h2>
                                    <div className="space-y-6">
                                        {section.items.map((item, iIdx) => (
                                            <div key={iIdx} className="pb-6" style={{ borderBottom: '1px solid #E7E5E4' }}>
                                                <h3 className="text-[#1C1917] text-sm font-normal mb-2">{item.subtitle}</h3>
                                                <p className="text-[#78716C] text-sm font-light leading-[1.8]">{item.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Contact CTA */}
                        <div className="mt-14 pt-10 text-center" style={{ borderTop: '1px solid #E7E5E4' }}>
                            <p className="text-[#78716C] text-sm font-light mb-2">Have questions?</p>
                            <p className="text-[#A8A29E] text-xs font-light">
                                Reach us at hello@sthir.in
                            </p>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default ShippingAndExchange10;
